const safelyDecodeURIComponent = (input: string) => {
  try {
    return decodeURIComponent(input);
  } catch {
    return input;
  }
};

export default safelyDecodeURIComponent;
